module.exports = __webpack_public_path__ + "static/media/img3.04f37dca.png";